import { Box } from 'src/components';

const SVGIcon = ({ size = 50, color = 'inherit', icon, sx = {}, ...rest }) => {
    const IconComponent = icon;

    return (
        <Box
        className="category-icon"
        sx={{
            width: size,
            height: size,
            color: color, 
            transition: 'transform 0.3s ease',
            ...sx,
        }}
        {...rest}
        >
        <IconComponent width={size} height={size} fill={color}/>
        </Box>
    );
};

export default SVGIcon;
